import {wideNavQuery} from '../00-base/global/utils/media';


export default (scroll_machine) => {
  const nav_header = document.getElementById('header-nav');
  const upper_link_cont = document.getElementById("quick-links");
  const upper_links = Array.from(upper_link_cont.querySelectorAll('.js-header__upper-menu-link'));
  const body = document.body;

  let is_contracted = true;

  if (window.cmhrBetaBannerSettings) {
    window.cmhrBetaBannerSettings.observeElementHeight(upper_link_cont, () => wideNavQuery.matches);
    window.cmhrBetaBannerSettings.observeElementHeight(nav_header);
    const breadcrumbs = document.getElementById("breadcrumbs-nav");
    if (breadcrumbs) {
      window.cmhrBetaBannerSettings.observeElementHeight(breadcrumbs);
    } 
  } 

  // expands nav on upper link focus
  if (wideNavQuery.matches) {
    upper_links.forEach((l) => l.addEventListener('focus', () => scroll_machine.runOnStartEnter()));
  }

  scroll_machine.addOnStart(() => {
    is_contracted = false;
    requestAnimationFrame(() => {
      body.classList.remove('is-header-contracted');
    });
  }, () => {
    is_contracted = true;
    requestAnimationFrame(() => {
      body.classList.add('is-header-contracted');
    });
  });

  // clear the inline styles on switch to mobile
  // triger scroll on mobile to adjust nav position
  wideNavQuery.addEventListener('change', (e) => {
    if (!e.matches) {
      scroll_machine.runOnStartEnter();
    } else if (scroll_machine.scrollY) {
      scroll_machine.runOnStartLeave();
    } else {
      scroll_machine.runOnStartEnter();
    }
  });
};
